module.exports = __webpack_public_path__ + "static/media/food-1.51373357.jpeg";